import { forwardRef, ChangeEvent, useEffect } from 'react';
import { FactoryOpts } from 'imask';
import { useIMask } from 'react-imask';
import { mergeRefs } from '@area-restrita/client';

import { Input, InputProps } from '@/components/ui/input';

export type IMaskedInputProps = {
  maskOptions: FactoryOpts;
} & InputProps;

export const MaskedInput = forwardRef<HTMLInputElement, IMaskedInputProps>(
  ({ value: controlledValue, maskOptions, onChange, ...props }, ref) => {
    const {
      ref: inputMaskRef,
      value,
      unmaskedValue,
      setValue,
    } = useIMask(maskOptions, {
      onAccept(_value, _maskRef, e?) {
        if (!e) return;

        onChange?.(e as unknown as ChangeEvent<HTMLInputElement>);
      },
    });

    useEffect(() => {
      if (!controlledValue) return;

      if (controlledValue !== value && controlledValue !== unmaskedValue) {
        setValue(controlledValue.toString());
      }
    }, [controlledValue, unmaskedValue, value, setValue]);

    return <Input ref={mergeRefs(ref, inputMaskRef)} {...props} />;
  },
);

export default MaskedInput;
